/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_6_DescInputs */

const en_mk_cap_6_desc = /** @type {(inputs: Mk_Cap_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI cost per agent and per run in rupiah, plus a spending cap that stops an agent before it overspends.`)
};

const id_mk_cap_6_desc = /** @type {(inputs: Mk_Cap_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya AI per agen dan per run dalam rupiah, plus batas belanja yang menghentikan agen sebelum kebablasan.`)
};

/**
* | output |
* | --- |
* | "AI cost per agent and per run in rupiah, plus a spending cap that stops an agent before it overspends." |
*
* @param {Mk_Cap_6_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_6_desc = /** @type {((inputs?: Mk_Cap_6_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_6_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_6_desc(inputs)
	return en_mk_cap_6_desc(inputs)
});